<template lang="pug">
  .component-credit-records
    .component-credit-record(v-if="$is('listing')")
      .inner-content
        .component-card
          .row
            .column.expanded
              h3.mb-0 PR{{item.id}}
              .field-value {{item.status}}
              small
                span {{item.type}}
                //span(v-if="item.type === 'USE'") &nbsp; {{item.walletable_type?item.walletable_type:'--'}} {{item.walletable_id?item.walletable_id:'--'}}
              //.description(slot="bottom") {{item.reason.replace('|',' - ')}}
            .column.shrink
              .fiel-content
                .label Created
                .field-value {{$dateFormat(item.created_at, $toMomentFormat(configuration.locale.locale_date_format.value))}}
            .column.shrink.pl-0
              dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
                PacketRecordButtons(:item="item")
          .row.text-center.pt-0
            .column
              .label Valid From
              .field-value(v-if="item.valid_from") {{$dateFormat(item.valid_from, $toMomentFormat(configuration.locale.locale_date_format.value))}}
              .field-value(v-else) --
            .column
              .label Valid To
              .field-value(v-if="item.valid_to") {{$dateFormat(item.valid_to, $toMomentFormat(configuration.locale.locale_date_format.value))}}
              .field-value(v-else) --
            .column
              .label Minutes
              h3.mb-0 {{item.minutes}}
            .column
              .label Distance
              h3.mb-0 {{item.distance}}
    .component-credit-record(v-if="$is('usages')")
      .inner-content
        .component-card
          .row
            .column
              label PR{{item.id}}
              .field-value {{item.status}}
              small
                span {{item.type}}
                span(v-if="item.type === 'USE'") &nbsp; {{item.walletable_type?item.walletable_type:'--'}} {{item.walletable_id?item.walletable_id:'--'}}
            .column
              .label Used minutes
              h3.mb-0 {{item.minutes}}
            .column
              .label Used distance
              h3.mb-0 {{item.distance}}
            .column
              .fiel-content
                .label Created
                .field-value {{item.created_at}}
</template>

<script>
  import CardN from '../structure/CardN'
  import {mapState} from 'vuex'
  import ActionButton from '../structure/ui/ActionButton'
  import CreditRecordButtons from '../structure/ui/actions/CreditRecordButtons'
  import Dropdown from '../structure/foundation/Dropdown'
  import PacketRecordButtons from "../structure/ui/actions/PacketRecordButtons.vue";

  export default {
    name: 'PacketRecord',
    components: {PacketRecordButtons, Dropdown, CreditRecordButtons, ActionButton, CardN},
    computed: {
      ...mapState({
        configuration: state => state.configuration,
      }),
    },
    props: ['item', 'type']
  }
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// PacketRecord.vue?a1f72e32